import { useStore } from 'react-redux'
import { useState, useEffect } from 'react'
import { clientFactory } from 'mage-core'
import useAvailableApps from '../merchant-orientation/hooks/useAvailableApps'

async function getPendingDisputes (client, setIsloading, setDisputesCount) {
  setIsloading(true)
  const pendingDisputes = await client.request({
    method: 'POST',
    url: '/disputes/search',
    data: { investigation_status: 'unresolved' }
  })

  const count = pendingDisputes.data.pagination.total
  setDisputesCount(count)
  setIsloading(false)
}

function useUnresolvedDisputesCount (tokenHelper) {
  const store = useStore()
  const [disputesCount, setDisputesCount] = useState(null)
  const [isLoading, setIsloading] = useState(false)
  const availableApps = useAvailableApps(tokenHelper)

  const isDisputesAvailable = availableApps.includes('disputes-fe')

  useEffect(() => {
    if (isDisputesAvailable) {
      const state = store.getState()
      const client = clientFactory(state)('/api/disputes')
      getPendingDisputes(client, setIsloading, setDisputesCount)
    }
  }, [store])

  return { data: disputesCount, isLoading }
}

export default useUnresolvedDisputesCount
